import { Component, inject } from '@angular/core';

import { ApThemeService } from '@ap/theme';

/**
 * @module ApGeldLenenKostGeldModule
 *
 * @ngdoc component
 * @name ApGeldLenenKostGeldComponent
 */
@Component({
    selector: 'ap-geld-lenen-kost-geld',
    templateUrl: './geld-lenen-kost-geld.component.html',
    styleUrls: ['./geld-lenen-kost-geld.component.scss']
})
export class ApGeldLenenKostGeldComponent {
    private readonly themeService = inject(ApThemeService);

    protected get src(): string {
        const staticUrl = this.themeService.getStaticUrl();
        return `${staticUrl}/illustration/geld-lenen-600.svg`;
    }
}
